<template>
    <section class="assessmentSection questionsSection page-aocStaging">
        <div class="pageContent">
            <header class="sectionHeader">
                    <div class="pageTitle hasSubtitle">Add an area of concern</div>
                    <div class="pageSubtitle">
                        Tell us about a room that concerns you and we will give you advice on how to protect it.
                    </div>
            </header>
            <section class="addAocButtonSection">
                <button class="addAocButton" @click="addArea"><span>+</span></button>
                <div>
                    <a class="addAocLink" href="javascript:;" @click="addArea">Add Area</a>
                </div>
            </section>
            <div class="aocStaging-areas-title" v-if="lead.areasOfConcern.length > 0">
                <div>
                    You've added {{ lead.areasOfConcern.length }} {{ lead.areasOfConcern.length > 1 ? 'areas' : 'area' }}
                </div>
                <div v-if="lead.protectionLevel === 'Total'">make sure to add all accessible areas</div>
            </div>
            <AreasOfConcernList />
        </div>
    </section>
</template>


<script>
import { mapActions, mapState } from 'vuex'
import AreasOfConcernList from '../components/AreasOfConcernList.vue'
export default {
    components: {
        AreasOfConcernList
    },
    computed: {
        ...mapState(['lead'])
    },
    methods: {
        ...mapActions([
            'incrementAocSectionIndex',
            'decrementAocSectionIndex',
            'setAocSectionIndex'
        ]),

        addArea() {
            this.incrementAocSectionIndex()
        }
    },

    mounted() {
        mixpanel.track('startedAoC')
    }
}
</script>

<style lang="css"></style>
